import { actions } from './snack.actions'
import { getters } from './snack.getters'
import { state } from './snack.state'
import { mutations } from './snack.mutations'

export default { actions, getters, state, mutations, namespaced: true }
